// import { useState } from "react";
// import Slider from "../components/home/CategorySlider";
import ProductCard from "../components/product/ProductCard";
import OfferCard from "../components/offer/OfferCard";
import TopSelling from "../components/topselling/TopSelling";

const Home = () => {
  // default category (Fruits = 1)
  // const [categoryId, setCategoryId] = useState(1);

  return (
    <div>
      {/* <Slider />; */}
      <OfferCard />;
      <TopSelling />
     <ProductCard />;
    </div>
  );
};

export default Home;
